import { render, staticRenderFns } from "./footerModel.vue?vue&type=template&id=029208bc&scoped=true"
import script from "./footerModel.vue?vue&type=script&lang=js"
export * from "./footerModel.vue?vue&type=script&lang=js"
import style0 from "./footerModel.vue?vue&type=style&index=0&id=029208bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029208bc",
  null
  
)

export default component.exports